module.exports = __webpack_public_path__ + "media/images/favicons/iit-c95adec26103b6cf90ab3170aea8902173964d2314f9846f2993a7a1defaa30b.ico";